import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function FoodIntroForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [foodItem, setFoodItem] = useState("");
  const [reaction, setReaction] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!foodItem) return;

    onAdd({
      date: new Date(date).toISOString(),
      foodItem: foodItem,
      reaction: reaction || "No reaction noted",
    });

    setDate(toDatetimeLocal());
    setFoodItem("");
    setReaction("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Food Item</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Peanut butter"
            value={foodItem}
            onChange={(e) => setFoodItem(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Reaction/Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Optional"
            value={reaction}
            onChange={(e) => setReaction(e.target.value)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add Introduction
          </button>
        </div>
      </div>
    </form>
  );
}
